<template>
  <div>
    <v-card
      max-width="428px"
      flat
      class="mx-auto custom-flat-card"
      elevation="0"
      color="background"
    >
      <v-card-text class="px-0">
        <h2
          class="text-capitalize mb-5 text-center font-Bold-24 gray1--text mb-6 login-form-title"
        >
          {{ $t("authPage.disableGaPage.title") }}
        </h2>
        <p class="my-10 text-center">
          {{
            $tc("authPage.disableGaPage.forRegisterOtp", model[state.disableBy])
          }}
        </p>
        <v-form @submit.prevent="onSubmit">
          <v-text-field
            name="otp"
            :placeholder="$t('authPage.disableGaPage.otpCode.placeholder')"
            type="text"
            filled
            autofocus
            v-model="otpCode"
            :rules="[
              () =>
                !!otpCode || $t('authPage.googleAuthPage.otpCode.validation')
            ]"
            class="custom-form-control login-form-control custom-otp-input custom-hover mb-6"
            color="primaryX"
            background-color="var(--v-field-base)"
            v-mask="'######'"
          ></v-text-field>
          <p
            class="text-center font-Medium-12 gray2--text mb-58"
            v-if="!isCounterExpired"
          >
            {{ $tc("authPage.otpAuthPage.timeTitle", countdownTimer) }}
          </p>
          <v-row
            align="center"
            justify="center"
            class="mx-0 mb-10"
            v-if="isCounterExpired"
          >
            <v-btn
              text
              color="primaryX"
              @click="resendOtpCode"
              depressed
              :loading="repeatLoading"
            >
              <span class="font-Medium-14">{{
                  $t("authPage.otpAuthPage.otpAuthResetButton")
                }}</span>
            </v-btn>
          </v-row>
          <v-btn
            :loading="loading"
            block
            depressed
            height="50"
            type="submit"
            color="primary"
            class="auth-submit-btn mb-8"
          ><span class="font-Medium-14">
              {{ $t("authPage.disableGaPage.loginButton") }}</span
          ></v-btn
          >
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import * as types from "@/store/types";
import { AuthService } from "@/services";
import showMessage from "@/components/Auth/GoogleAuth/showMessage.vue";

export default {
  props: ["model", "state"],
  data() {
    return {
      otpCode: "",
      countdownTimer: "",
      isCounterExpired: false,
      repeatLoading: false,
      clockInterval: "",
      loading: false,
      rules: {
        required: value =>
          !!value || this.$t("authPage.emailAuthPage.otpCode.validation")
        // min: v => v.length >= 8 || "Min 8 characters",
        // emailMatch: () => `The email and password you entered don't match`
      }
    };
  },
  computed: {
    otpToken() {
      return localStorage.getItem("otpToken");
    },
    emailOrMobile() {
      return localStorage.getItem("emailOrMobile");
    }
  },
  mounted() {
    this.countdown(this.state.ttl);
  },
  methods: {
    ...mapActions({
      checkIsAuth: types.auth.actions.ACTION_CHECK_IS_AUTH
    }),
    onSubmit() {
      this.loading = true;
      this.verifyUserOtp();
    },
    countdown(distance) {
      distance = distance / 1000;
      this.clockInterval = setInterval(() => {
        distance--;
        let minutes = Math.floor(distance / 60);
        let seconds = Math.floor(distance % 60);
        if (minutes < 10) {
          minutes = "0" + minutes;
        }
        if (seconds < 10) {
          seconds = "0" + seconds;
        }
        let x = minutes + ":" + seconds;
        if (distance < 0) {
          this.countdownTimer = "00:00";
          this.isCounterExpired = true;
          clearInterval(this.clockInterval);
        } else {
          this.countdownTimer = x;
        }
      }, 1000);
    },
    verifyUserOtp() {
      let otpToken = localStorage.getItem("otpToken");
      AuthService.disableGA({ otp_code: this.otpCode, token: otpToken })
        .then(res => {
          if (res.status === 200) {
            localStorage.removeItem("otpToken");
            this.$emit("changeComponent", showMessage);
          }
        })
        .catch(() => {
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    resendOtpCode() {
      try {
        this.repeatLoading = true;
        this.$emit("submitHandler");
        this.countdown(this.state.ttl);
        this.isCounterExpired = !this.isCounterExpired;
      } catch (e) {
        this.repeatLoading = false;
      } finally {
        this.repeatLoading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.mb-58 {
  margin-bottom: 58px;
}
</style>
